// App.vue
<template>
  <div class="app">
    <router-view></router-view>
    <template>
  <div class="bg-blue-500 text-white p-4 rounded-lg">
    Hello!
  </div>
</template>
  </div>
</template>

<script>
// import { useAnalytics } from '@/config/analytics.js'

export default {
  name: 'App',
}
// useAnalytics()

</script>